import { SET_OPEN_MOBILE_MENU } from '../constants/ActionTypes';


export default function fetchMe(value) {
  return {
    type: SET_OPEN_MOBILE_MENU,
    value: value
  }
}

